/* eslint-disable react/forbid-prop-types,import/prefer-default-export */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import Input from '../../../../components/Input';
import { getMaskedPhoneNumber } from '../../../../utilities/helpers';
import { OnboardingBodyLayout } from '../partials';

export const ConfirmPhoneNumberComponent = ({
  form,
  handleSubmit,
  handleResendOnClick,
  renderButtons,
  handleChange,
  timer,
  isLoading,
  state,
}) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <OnboardingBodyLayout
      title={translate('confirm_phone_number_title_label')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <form onSubmit={handleSubmit} id="confirm-phone-form">
        <Input
          subLabel={`${translate('confirm_phone_number_message_label_nosec').replace(
            '%s',
            getMaskedPhoneNumber(form?.confirmed_phone_number, state?.country_code)
          )} ${timer} ${translate('email_verification_subtext_label_sec')}`}
          value={form.code}
          name="code"
          type="number"
          onChange={handleChange}
          actionLabel={translate('resend_button_label')}
          actionClick={handleResendOnClick}
          actionDisabled={isLoading || timer > 0}
          placeholder={translate('confirm_phone_number_code_label')}
          label={translate('confirm_phone_number_code_label')}
          errorLabel={translate('verification_code_error_label')}
          groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
          className={`${isIOS ? 'ios' : ''}`}
          withFloatingLabel
          withSubLabel
          withErrorLabel
          autoComplete="off"
          actionBtnTop="18%"
        />
      </form>
    </OnboardingBodyLayout>
  );
};

ConfirmPhoneNumberComponent.propTypes = {
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleResendOnClick: PropTypes.func.isRequired,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  timer: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  state: PropTypes.object.isRequired,
};
